"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPreDefinedMessageAvailable = exports.getPreDefinedMessageAvailable = void 0;
var _reselect = require("reselect");
var _chatSelector = require("./chatSelector");
// ====================================================================
// Constants
// ====================================================================

var buyerMessages = ['Aceita oferta?', 'Aceita troca?', 'Ainda está disponível?', 'Tenho interesse!'];
var sellerMessages = ['Desculpe, não aceito oferta.', 'Qual é a sua oferta?', 'Desculpe, já vendi.', 'Sim, ainda está disponível.'];

// ====================================================================
// Select data from * state *
// ====================================================================

var _getCurrentRoomname = function _getCurrentRoomname(_ref) {
  var currentChat = _ref.currentChat;
  return currentChat;
};
var _getPreDefinedMsgUsed = function _getPreDefinedMsgUsed(_ref2) {
  var preDefinedMessage = _ref2.preDefinedMessage;
  return preDefinedMessage;
};
var _getPreDefinedMsgAvailable = function _getPreDefinedMsgAvailable(state) {
  return (0, _chatSelector.amISeller)(state) ? sellerMessages : buyerMessages;
};

// ====================================================================
// Selectors
// ====================================================================

var getPreDefinedMsgUsedByRoomname = (0, _reselect.createSelector)([_getCurrentRoomname, _getPreDefinedMsgUsed], function (currentRoomname, preDefinedMsgUsed) {
  return preDefinedMsgUsed[currentRoomname] || [];
});
var getPreDefinedMessageAvailable = exports.getPreDefinedMessageAvailable = (0, _reselect.createSelector)([getPreDefinedMsgUsedByRoomname, _getPreDefinedMsgAvailable], function (preDefinedMessageUsed, preDefinedMsgAvailable) {
  return preDefinedMsgAvailable.filter(function (message) {
    return !preDefinedMessageUsed.includes(message);
  });
});
var hasPreDefinedMessageAvailable = exports.hasPreDefinedMessageAvailable = (0, _reselect.createSelector)([getPreDefinedMsgUsedByRoomname, _getPreDefinedMsgAvailable], function (preDefinedMessageUsed, preDefinedMsgAvailable) {
  return preDefinedMsgAvailable.length > preDefinedMessageUsed.length;
});